import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import UsageStatsList from './UsageStatsList';
import UsageStatsListService from '../services/UsageStatsListService';
import UsageStatsStudentListDialogService from '../services/UsageStatsStudentListDialogService';

class UsageStatsListContainer extends Component {

  componentDidMount() {
    UsageStatsListService.init();
  }

  render() {
    return (
      <UsageStatsList
        companies={toJS(UsageStatsListService.companies)}
        fetching={UsageStatsListService.fetch.fetching}
        onShowDetails={UsageStatsStudentListDialogService.handleShow}
      />
    );
  }
}

export default observer(UsageStatsListContainer);
